import BCImageUpload from '../../../BCImageUpload';
import { IPropertyComponentProps } from '../../entities';

export default function ImageUploadProperty(props: IPropertyComponentProps) {
	const onValueChange = (value: any) => {
		props.onValueChanged(props.item, value);
	};

	return (
		<BCImageUpload
			name={props.item?.externalData?.name}
			accept="image/*"
			listType="picture-card"
			maxCount={1}
			showRemoveIcon
			showPreviewIcon
			value={props.value}
			multiple={false}
			onValueChange={onValueChange}
			disabled={props.readonly}
		/>
	);
}
